import { useNavigate } from 'react-router-dom'
import { FormProvider, useForm } from 'react-hook-form'
import { login } from 'api/auth/login'
import { Button } from 'components/atoms/buttons/Button'
import { InputText } from 'components/atoms/inputs/InputText'
import swal from 'sweetalert2'
import { useRecoilState } from 'recoil'
import { AuthState } from 'recoil/atoms/auth.atom'
import { zodResolver } from '@hookform/resolvers/zod'
import { FormValues, LoginSchema } from 'schema/auth/LoginSchema'

export const Login = (): JSX.Element => {
  const navigate = useNavigate()
  const methods = useForm<FormValues>({
    defaultValues: { loginId: '', password: '' },
    resolver: zodResolver(LoginSchema)
  })
  const [, setAuth] = useRecoilState(AuthState)

  const onSubmit = async (data: FormValues) => {
    try {
      await login(data).then((response: any) => {
        const token = response.data.data
        localStorage.setItem('auth', JSON.stringify(token))
        setAuth(response.data.data.authorityCode)
        if (token) navigate('/company')
      })
    } catch (error: any) {
      await swal.fire({ icon: 'error', text: error.data.message })
    }
  }

  return (
    <div className={'flex h-screen w-screen flex-row content-center'}>
      <div
        className={'flex w-full flex-col items-center justify-center space-y-3'}
      >
        <div className={'w-96'}>
          <img src="/logo.png" alt="accum" className={'pointer-events-none'} />
        </div>
        <FormProvider {...methods}>
          <form
            onSubmit={methods.handleSubmit(onSubmit)}
            className="w-96 space-y-8 p-2"
          >
            <div className="space-y-4 p-2">
              <InputText
                name={'loginId'}
                label={'ログインID'}
                required
                autoComplete="on"
              />
              <InputText
                name={'password'}
                label={'パスワード'}
                required
                type="password"
              />
            </div>
            <div className="flex w-full justify-center">
              <div className={'w-40'}>
                <Button label={'Login'} />
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  )
}
